import { z } from "zod";

export const schema = z.object({
    datum: z.string().min(1, "forms.general-validation.date_required"),
    uzivatel: z.string().min(1, "forms.general-validation.user_required"),
    zeme: z.string().min(1, "forms.general-validation.country_required"),
    flagCode: z.string().min(1, "forms.general-validation.flag_code_required"),
    kategorie: z.string().min(1, "forms.general-validation.category_required"),
    nabidka: z.string().min(1, "forms.general-validation.offer_required"),
    typ: z.enum(["Click", "Lead", "iFrame"]).refine((value) => !!value, {
        message: "forms.general-validation.type_required",
    }),
    odmena: z.string().min(1, "forms.general-validation.reward_required"),
    castka: z.string().min(1, "forms.general-validation.amount_required"),
});

export type AddFinanceCostsFormData = z.infer<typeof schema>;
